import AdBanner from "./AdBanner";

/** Sticky sidebar column with a skyscraper ad */
const Sidebar = ({ side }) => (
  <aside
    data-testid={`ad-sidebar-${side}`}
    className={`hidden xl:flex flex-col items-center w-[180px] shrink-0 py-4 px-2 bg-zinc-50/50 ${side === 'left' ? 'border-r' : 'border-l'} border-zinc-100`}
  >
    <div className="sticky top-[57px] w-full">
      <AdBanner size="skyscraper" />
    </div>
  </aside>
);

/**
 * PageAdLayout — wraps page content with ads on all 4 sides.
 *
 * Props:
 *   topSection  – full-width JSX rendered between the top ad and the 3-column area
 *   children    – main page content (goes in the center column)
 */
const PageAdLayout = ({ children, topSection }) => (
  <>
    {/* ── TOP AD ── */}
    <div
      data-testid="ad-top"
      className="bg-white border-b border-zinc-100 py-2 px-4"
    >
      <AdBanner size="leaderboard" className="max-w-5xl mx-auto" />
    </div>

    {/* ── FULL-WIDTH SECTION (e.g. progress bar, group header) ── */}
    {topSection}

    {/* ── 3-COLUMN BODY ── */}
    <div className="flex flex-1 min-h-0">
      <Sidebar side="left" />

      {/* Center — main content */}
      <div className="flex-1 min-w-0">
        {children}
      </div>

      <Sidebar side="right" />
    </div>

    {/* ── BOTTOM AD ── */}
    <div
      data-testid="ad-bottom"
      className="bg-white border-t border-zinc-100 py-3 px-4"
    >
      <AdBanner size="leaderboard" className="max-w-5xl mx-auto" />
    </div>
  </>
);

export default PageAdLayout;
